import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import styled from "styled-components";
import { IBackButtonContainerProps } from "./types";

export const BackButtonContainer = styled.div<IBackButtonContainerProps>(
    ({ theme, hasScrolledBackground, position, top, left, zIndex }) => ({
        width: "100vw",
        height: "60px",
        display: "flex",
        alignItems: "center",
        paddingLeft: left ?? theme.spacing.medium,
        transition: "all 0.2s ease",
        position,
        top: top ?? "0px",
        left: "0px",
        zIndex,
        backgroundColor: hasScrolledBackground
            ? theme.colors[theme.colorMode].background_Primary
            : "transparent",
        boxShadow: hasScrolledBackground ? theme.elevation[theme.colorMode].skim.boxShadow : "none",
    })
);

export const BackButtonIcon = styled.div(() => ({
    height: "40px",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    backgroundColor: "transparent",
}));

export const BackButtonTitle = styled(Text)(({ theme }) => ({
    marginLeft: theme.spacing.small,
    marginTop: theme.spacing.xxxSmall,
}));
